import { AutogenModelEdiUser, AutogenRowEdiUser } from "./autogen/AutogenModelEdiUser";

export class ModelEdiUser extends AutogenModelEdiUser<RowEdiUser> {
    constructor() {
        super(RowEdiUser);
    }
}

export class RowEdiUser extends AutogenRowEdiUser {
}